import { render, staticRenderFns } from "./hero-name.vue?vue&type=template&id=37534a00&scoped=true&"
import script from "./hero-name.vue?vue&type=script&lang=js&"
export * from "./hero-name.vue?vue&type=script&lang=js&"
import style0 from "./hero-name.vue?vue&type=style&index=0&id=37534a00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37534a00",
  null
  
)

export default component.exports